import { useState } from 'react';
import { ScheduleDefinition } from '@weave/schema-gen-ts/dist/schemas/schedule/v3/schedule_definitions.pb';
import { useModalControl } from '@frontend/design-system';

export const useAvailabilityRuleTray = () => {
  const { modalProps: editModalProps, openModal } = useModalControl();
  const [selectedScheduleDefinition, setSelectedScheduleDefinition] = useState<ScheduleDefinition | null>(null);
  const [isCopyMode, setIsCopyMode] = useState(true);
  const [selectedResourceId, setselectedResourceId] = useState<string | undefined>(undefined);

  const isEditMode = !isCopyMode && !!selectedScheduleDefinition;

  const openAddEditTray = (
    scheduleDefinition: ScheduleDefinition | null,
    resourceId: string | undefined,
    isCopy = false
  ) => {
    setSelectedScheduleDefinition(scheduleDefinition);
    setselectedResourceId(resourceId);
    setIsCopyMode(isCopy);
    openModal();
  };

  const editModalOnClose = () => {
    openAddEditTray(null, undefined, false);
    editModalProps.onClose();
  };

  return {
    editModalProps,
    selectedScheduleDefinition,
    openAddEditTray,
    editModalOnClose,
    setIsCopyMode,
    isEditMode,
    selectedResourceId,
  };
};
